// Pure decision for what the /admin route should do, given the available token + config.
// Kept separate from the React component so it can be unit-tested without a DOM.
//
//   render   — an admin-authorized token is present; show the console.
//   redirect — no admin token, a demo admin entry is configured, and we did NOT just come
//              back from it (no token in the URL) → bounce there to mint a fresh admin token.
//   notice   — no admin token and no (usable) demo entry → show the Hebrew auth notice.
//
// The `!hasUrlToken` guard on redirect prevents a loop: if the demo entry sent us back with a
// token that still is not admin-authorized, we show the notice instead of redirecting again.

export type AdminGate =
  | { kind: "render" }
  | { kind: "redirect"; url: string }
  | { kind: "notice" };

export function decideAdminGate(args: {
  adminToken: string;
  hasUrlToken: boolean;
  demoEntryUrl?: string;
}): AdminGate {
  if (args.adminToken) return { kind: "render" };
  if (args.demoEntryUrl && !args.hasUrlToken) return { kind: "redirect", url: args.demoEntryUrl };
  return { kind: "notice" };
}
